export default {
  Welcome: 'Welcome',
  Contact: 'Contact',
  Confirm: 'Confirm',
  Interview: 'Interview',
};
